<template>
  <div class="pay-center-address-component"
       :class="[
         { 'is-show-hint': showHint }
       ]"
       @click="handleChoseAddress"
  >
    <div class="pay-center-address-content">
      <template v-if="!address.value">
        <div class="pay-center-address-empty">
          暂无可用收件地址
        </div>
        <ym-button size="large">
          <ym-icon name="plus" />
          添加收件地址
        </ym-button>
      </template>

      <div v-else
           class="pay-center-address-value"
      >
        <order-address class="pay-center-address-value--left"
                       :recipient="address.value.recipient"
                       :mobile="mobile"
                       :region="address.value.region"
                       :detail="address.value.particulars || address.value.detail"
        />
        <ym-icon class="pay-center-address-right" name="right" />
      </div>
      <div v-if="showHint"
           class="pay-center-address-hint ym-hairline--top"
      >
        {{ address.hint }}
      </div>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import OrderAddress from '@/pages/Order/components/OrderAddress';
  import { formatMobile } from '@/utils';

  export default {
    name: 'PayCenterAddress',
    components: {
      'ym-button': Button,
      OrderAddress,
    },
    props: {
      address: {
        type: Object,
        required: true,
      },
      redirectTo: {
        type: String,
      },
    },
    computed: {
      showHint() {
        return this.address.hint !== '';
      },
      mobile() {
        return formatMobile(this.address.value.mobile);
      },
    },
    methods: {
      handleChoseAddress() {
        const { redirectTo } = this;
        const route = {
          name: 'AddressSetting',
          query: {
            redirectTo,
            choseAddress: 1,
          },
        };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-address {
    &-component {
      margin-bottom: @size-small;
      padding: @size-base @size-medium @size-extra-medium;
      background: @color-white;

      &.is-show-hint {
        padding-bottom: @size-base;
      }
    }

    &-empty {
      margin: @size-extra-small auto @size-base;
      text-align: center;
      color: @color-text-lighter;
    }

    &-value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;
    }

    &-hint {
      margin-top: @size-small;
      padding-top: @size-small;
      font-size: @font-size-small;
      color: @color-text-lighter;
    }

    &-right {
      flex-shrink: 0;
      margin-right: -8px;
      font-size: 32px;
      color: @color-text-lighter;
    }
  }
</style>
